module.exports = __webpack_public_path__ + "static/media/react.a8d2584f.png";